import gql from 'graphql-tag';

const DELETE_BLACKLIST_ITEM = gql`
    mutation deleteItem($ean: String) {
        deleteItem (ean: $ean) {
            internalCode
        }
    }
`;

export default DELETE_BLACKLIST_ITEM;
